module.exports = __webpack_public_path__ + "fonts/Inter-100-cyrillic-ext4.47734ae.woff2";